const Attributes = {
    url: {
        type: 'string',
        default: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
    },
    urltype: {
        type: 'string',
        default: 'mp4'
    },
    youtubeurl: {
        type: 'string',
        default: 'Gaosub7FRf4'
    },
    facebookurl: {
        type: 'string',
        default: ''
    },
    vimeourl: {
        type: 'string',
        default: '90509568'
    },
    twitchurl: {
        type: 'string',
        default: ''
    },
    wistiaurl: {
        type: 'string',
        default: ''
    },
    dailymotionurl: {
        type: 'string',
        default: ''
    },
    vidyardurl: {
        type: 'string',
        default: ''
    },
    streamableurl: {
        type: 'string',
        default: ''
    },
    pip: {
        type: 'boolean',
        default: false
    },
    playing: {
        type: 'boolean',
        default: false
    },
    controls: {
        type: 'boolean',
        default: false
    },
    light: {
        type: 'boolean',
        default: false
    },
    volume: {
        type: 'number',
        default: '0.8'
    },
    muted: {
        type: 'boolean',
        default: false
    },
    played: {
        type: 'number',
        default: '0'
    },
    loaded: {
        type: 'number',
        default: '0'
    },
    duration: {
        type: 'number',
        default: '0'
    },
    playbackRate: {
        type: 'number',
        default: '1.0'
    },
    loop: {
        type: 'boolean',
        default: false
    },
    poster: {
        type: 'string',
        default: 'https://images.pexels.com/photos/16516/pexels-photo.jpg?auto=compress&h=342&w=610'
    },
    width: {
        type: 'string',
        default: '100%'
    },
    height: {
        type: 'string',
        default: '100%'
    },
    bigplayHide: {
        type: 'boolean',
        default: true
    },
    pipcontrols: {
        type: 'boolean',
        default: true
    },
    bigplayctr: {
        type: 'boolean',
        default: true
    },
    playcontrols: {
        type: 'boolean',
        default: true
    },
    restartcontrols: {
        type: 'boolean',
        default: true
    },
    rewindcontrols: {
        type: 'boolean',
        default: true
    },
    forwardcontrols: {
        type: 'boolean',
        default: true
    },
    progresscontrols: {
        type: 'boolean',
        default: true
    },
    mutecontrols: {
        type: 'boolean',
        default: true
    },
    volumecontrols: {
        type: 'boolean',
        default: true
    },
    downloadcontrols: {
        type: 'boolean',
        default: true
    },
    fullscreencontrols: {
        type: 'boolean',
        default: true
    },
    customurl: {
        type: 'string',
        default: ''
    },
    devurl: {
        type: 'boolean',
        default: false
    },
    styleinfo: {
        type: 'array',
        default: []
    },
    extraControl: {
        type: 'array',
        default: []
    },
    radius: {
        type: 'obejct',
        default: {
            top: '0%',
            left: '0%',
            right: '0%',
            bottom: '0%',
        }
    }
}
export default Attributes